import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactQuill from 'react-quill';
import { Helmet } from 'react-helmet';
// import imageFileIcon from '../../assets/icons/image-file-icon.svg';

import classes from './MarkdownInputField.module.css';
import 'react-quill/dist/quill.snow.css';

// var icons = ReactQuill.Quill.import('ui/icons');
// icons['bold'] = '<img src="https://s3.ap-south-1.amazonaws.com/edyoda/public/Assets/Icons/icon-bold-blue.png" style="width: 14px; height: 14px" aria-hidden="true" alt="bold" />';
// icons['italic'] = '<img src="https://s3.ap-south-1.amazonaws.com/edyoda/public/Assets/Icons/icon-italics-blue.png" style="width: 14px; height: 14px" aria-hidden="true" alt="italic" />';
// icons['underline'] = '<img src="https://s3.ap-south-1.amazonaws.com/edyoda/public/Assets/Icons/icon-underline-blue.png" style="width: 14px; height: 14px" aria-hidden="true" alt="underline" />';
// icons['link'] = '<img src="https://s3.ap-south-1.amazonaws.com/edyoda/public/Assets/Icons/icon-link-blue.png" style="width: 15px; height: 14px" aria-hidden="true" alt="link" />';
// icons['list'] = '<img src="https://s3.ap-south-1.amazonaws.com/edyoda/public/Assets/Icons/icon-list-blue.png" style="width: 15px; height: 15px" aria-hidden="true" alt="list" />';
// icons['image'] = `<img src=${imageFileIcon} style="width: 15px; height: 15px" aria-hidden="true" alt="list" />`;

class MarkdownInputField extends Component {
    /* 
    * Quill modules to attach to editor
    * See https://quilljs.com/docs/modules/ for complete options
    */
    modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }, { 'font': [] }, { 'align': [] }],
            [{ 'color': [] }, { 'background': [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            this.props.showImageOption === true ? ['link', 'image'] : ['link'],
            [{ 'script': 'sub' }, { 'script': 'super' }],
        ],
        clipboard: {
            matchVisual: false
        }
    }

    /* 
    * Quill editor formats
    * See https://quilljs.com/docs/formats/
    */
    formats = [
        'header', 'bold', 'italic', 'underline',
        'strike', 'blockquote', 'code-block',
        'list', 'bullet', 'indent',
        'link', 'image',
        "font",
        "size",
        "align",
        "script",
        "background",
        "color",
    ]

    state = {
        fieldFocussed: false,
        value: '',
    }

    onFocus = () => {
        this.setState({ fieldFocussed: true });
    }

    onBlur = () => {
        this.setState({ fieldFocussed: false });
    }

    componentDidMount() {
        this.setState({ value: this.props.value });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.props.value });
        }
    }

    onChange = (text) => {
        if (this.props.notEditable === true) {
            return;
        } else {
            this.setState({ value: text });
            this.props.onChange(text);
        }
    }

    render() {
        return (
            <div>
                <Helmet>
                    <link rel="stylesheet" href="//cdn.quilljs.com/1.2.6/quill.snow.css" />
                </Helmet>
                {
                    this.props.notEditable === true
                        ? <ReactQuill
                            className={[classes.QuillEditor, (!this.props.forEditPage && !this.state.fieldFocussed) ? classes.ExtraPadding : null, classes.FullHeight].join(' ')}
                            value={this.state.value}
                            // modules={this.state.fieldFocussed ? this.modules : { toolbar: [] }}
                            placeholder={''}
                            theme="snow"
                            readOnly={true}
                            modules={{
                                toolbar: [],
                                clipboard: {
                                    matchVisual: false
                                }
                            }}
                            formats={this.formats}></ReactQuill>
                        : <ReactQuill
                            className={[classes.QuillEditor, (!this.props.forEditPage && !this.state.fieldFocussed) ? classes.ExtraPadding : null, this.props.fullScreen ? classes.FullScreen : null].join(' ')}
                            onChange={this.onChange}
                            value={this.state.value}
                            // modules={this.state.fieldFocussed ? this.modules : { toolbar: [] }}
                            placeholder={''}
                            onFocus={this.onFocus}
                            theme="snow"
                            modules={this.modules}
                            formats={this.formats}></ReactQuill>
                }
            </div>
        )
    }
}

/* 
* PropType validation
*/
MarkdownInputField.propTypes = {
    placeholder: PropTypes.string,
}

export default MarkdownInputField;